import { QueryClient, MutationCache } from "@tanstack/react-query";

// Dispatch a DOM event so the ToastProvider (inside React) can show a message
// without creating a circular dependency between queryClient and React contexts.
function dispatchMutationError(err) {
  if (typeof window === "undefined") return;
  window.dispatchEvent(
    new CustomEvent("query:mutation-error", {
      detail: { message: err?.message || "Something went wrong" },
    }),
  );
}

export const queryClient = new QueryClient({
  mutationCache: new MutationCache({
    onError: dispatchMutationError,
  }),
  defaultOptions: {
    queries: {
      staleTime: 30_000, // 30 s before data is considered stale
      gcTime: 5 * 60_000, // 5 min before unused data is garbage-collected
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});
